// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".personal-information-wrapper[data-v-55f6028c] .justify-content-start{justify-content:flex-start!important}.personal-information-wrapper[data-v-55f6028c] .svg.eye{margin-bottom:5px}.personal-information-wrapper[data-v-55f6028c] .form-control.overflow-x{height:55px;padding:12px;display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
